import { LoadingButton } from '@mui/lab';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { PeopleService } from '../../Component/Api/People/peopleService';
import { ConfirmationDialog } from '../../Component/Common/Components/ConfirmationDialog';
import { DataTable } from '../../Component/Common/Components/DataTable/DataTable';
import { IFilter } from '../../Component/Common/Components/DataTable/Filters';
import { InformationDialog } from '../../Component/Common/Components/InformationDialog';
import { ColumnSortOption } from '../../Component/Model/Dto/ColumnSortOption';
import { PeopleDtos } from '../../Component/Model/Dto/People';
import { ExportKeyValue } from '../../Component/Model/Dto/Upload';
import { DataImportType } from '../../Component/Model/Enum/BEE123Enums';
import { EntriesPerPage, IBulkActions } from '../../Component/Model/Table/Table';
import { emptyGuid } from '../../Helpers/typescriptHelper';
import { ImportExportButtonsDialog } from '../Common/ImportAndExport/ImportExportButtonsDialog';

import { PeopleModal } from './PeopleModal/PeopleModal';
import { PeopleTableMapper } from './PeopleTable';

const peopleFilters: Array<IFilter> = [
    {
        label: 'Gender:',
        values: [{ key: 'Male', val: 1 }, { key: 'Female', val: 2 }],
        type: 1, propname: 'genderIds',
        //action: () => { } - for individual filter change handles
    },
    {
        label: 'Race:',
        values: [{ key: 'African', val: 1 }, { key: 'Coloured', val: 2 }, { key: 'Indian', val: 3 }, { key: 'White', val: 4 }, { key: 'Non South African', val: 5 }],
        type: 1, propname: 'raceIds',

    },
    {
        label: 'Occupation Level:',
        values: [{ key: 'Executive Director', val: 1 },
        { key: 'Non Executive Director', val: 2 },
        { key: 'Executive Management', val: 3 },
        { key: 'Other Executive Management', val: 4 },
        { key: 'Senior Management', val: 5 },
        { key: 'Middle Management', val: 6 },
        { key: 'Junior Management', val: 7 },
        { key: 'Semi skilled', val: 8 },
        { key: 'Unskilled', val: 9 },
        { key: 'Unspecified', val: 10 }],
        type: 1, propname: 'occupationalLevelIds'

    },
    {
        label: 'Employee Type:',
        values: [
            { key: 'Employed By Other', val: 2 },
            { key: 'Employee', val: 1 },
            { key: 'Employee Previously Unemployed', val: 4 },
            { key: 'Unemployed', val: 3 }],
        type: 1, propname: 'employeeTypeIds'
    },
    {
        label: 'Disabled:',
        values: [{ key: 'Yes', val: true }, { key: 'No', val: false }],
        type: 1, propname: 'disabledValues'

    },
    {
        label: 'Province:',
        values: [
            { key: 'Unspecified', val: 0 },
            { key: 'National (NAT)', val: 1 },
            { key: 'Eastern Cape (EC)', val: 2 },
            { key: 'Free State (FS)', val: 3 },
            { key: 'Gauteng (GP)', val: 4 },
            { key: 'KwaZulu-Natal (KZN)', val: 5 },
            { key: 'Limpopo (LP)', val: 6 },
            { key: 'Mpumalanga (MP)', val: 7 },
            { key: 'North West (NW)', val: 8 },
            { key: 'Northern Cape (NC)', val: 9 },
            { key: 'Western Cape (WC)', val: 10 },
        ],
        type: 1, propname: 'provinceIds'
    },
    {
        label: 'Y.E.S. Employee:',
        values: [{ key: 'Yes', val: true }, { key: 'No', val: false }],
        type: 1, propname: 'isYesEmployeeValues'

    },
    {
        label: 'Y.E.S. Absorbed:',
        values: [{ key: 'Yes', val: true }, { key: 'No', val: false }],
        type: 1, propname: 'isYesAbsorbedValues'

    },
    {
        label: 'Start Period',
        values: [],
        type: 3, propname: 'startDateRange',

    },
    {
        label: 'Termination Period',
        values: [],
        type: 3, propname: 'endDateRange',

    }
];

export const PeopleDatatableWithActions = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [peopleData, setPeopleData] = useState<PeopleDtos.PeopleSearchRow[]>([]);
    const [showCreatePeopleModal, setShowCreatePeopleModal] = useState<boolean>(false);
    const [personId, setPersonId] = useState<number>(0);
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);

    const [showInformationDialog, setShowInformationDialog] = useState(false);
    const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false);
    const [isConfirmationLoading, setIsConfirmationLoading] = useState<boolean>(false);
    const [scorecardNames, setScorecardNames] = useState<string[]>([]);

    const [showRemoveUnusedPeopleDialog, setShowRemoveUnusedPeopleDialog] = useState<boolean>(false);
    const [isRemoveLoading, setIsRemoveLoading] = useState<boolean>(false);
    const [removePeopleMessage, setRemovePeopleMessage] = useState('');
    const [informationMessage, setInformationMessage] = useState('');

    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>("");
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption[]>([]);
    const [filters, setFilters] = useState({});

    const peopleSearchRequest: PeopleDtos.PeopleSearchRequest = {
        pageNumber: pageNumber,
        pageSize: entriesPerPage.defaultValue!,
        searchValue: searchValue,
        registrationId: emptyGuid,
        scorecardIds: [],
        genderIds: [],
        raceIds: [],
        employeeTypeIds: [],
        disabledValues: [],
        occupationalLevelIds: [],
        provinceIds: [],
        isYesEmployeeValues: [],
        isYesAbsorbedValues: [],
        startDateFrom: undefined,
        startDateTo: undefined,
        endDateFrom: undefined,
        endDateTo: undefined,
        columnSortOptions: columnSortOptions
    };

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
        setPageNumber(1);
    }

    const columnSortingChanged = (sortOption: ColumnSortOption) => {
        setColumnSortOptions([sortOption]);
        setPageNumber(1);
    }

    const filtersChanged = (filterProps: any) => {
        let startDateFrom = filterProps['startDateRange']?.start;
        let startDateTo = filterProps['startDateRange']?.end;
        let endDateFrom = filterProps['endDateRange']?.start;
        let endDateTo = filterProps['endDateRange']?.end;
        setFilters({ ...filterProps, startDateFrom, startDateTo, endDateFrom, endDateTo });
    }

    const onEditPeopleRow = (id: number) => {
        setPersonId(id);
        setShowCreatePeopleModal(true);
    }

    const onAddPeople = () => {
        setPersonId(0);
        setShowCreatePeopleModal(true);
    }

    const bulkActions: IBulkActions[] = [
        {
            label: 'Create Person',
            action: onAddPeople
        }
    ]

    const closeModal = () => {
        fetchData();
        setShowCreatePeopleModal(false);
    }

    const onDeletePeopleRow = async () => {
        setIsConfirmationLoading(true);
        try {
            const result = await PeopleService.DeletePerson(personId);
            toast.success('Person deleted successfully');
            fetchData();
        } catch (error: any) {

            if (error.response.status === 400) {
                const response: string = error.response.data.toString();
                if (response !== undefined && response !== null) {
                    setInformationMessage(response.split(";")[0]);
                    setScorecardNames(response.split(";")?.splice(1));
                    setShowInformationDialog(true);
                }
            }
        } finally {
            setIsConfirmationLoading(false);
            setShowConfirmationDialog(false);
        }
    }

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let request = { ...peopleSearchRequest, ...filters };
            let resp = await PeopleService.SearchPeople(request);
            if (resp.data) {
                setPeopleData(resp.data.results);
                setFilteredItemsCount(resp.data.filteredItemsCount);
                setTotalItemsCount(resp.data.totalItemsCount);
            }
        } catch (error) {
            console.log(error);
            setFilteredItemsCount(0);
            setTotalItemsCount(0);
        } finally {
            setIsLoading(false);
        }
    }

    const handleCloseConfirmation = () => {
        setShowConfirmationDialog(false);
        setPersonId(0);
    }

    const handleDelete = (id: number) => {
        setPersonId(id);
        setShowConfirmationDialog(true);
    }

    const unusedPeopleClick = async () => {
        setIsRemoveLoading(true);
        try {
            let response = await PeopleService.GetUnusedPeople();
            if (response.data > 0) {
                setRemovePeopleMessage(`${response.data} person(s) will be removed. Are you sure you want to continue?`);
                setShowRemoveUnusedPeopleDialog(true);
            } else {
                toast.info("No People to Remove");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsRemoveLoading(false);
        }
    }

    const removeUnusedPeople = async () => {
        setIsConfirmationLoading(true);
        try {
            await PeopleService.RemoveUnusedPeople();
            toast.success("Successfully Removed Unused People");
        } catch (error) {
            console.log(error);
        } finally {
            fetchData();
            setIsConfirmationLoading(false);
            setShowRemoveUnusedPeopleDialog(false);
        }
    }

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [entriesPerPage, pageNumber, searchValue, columnSortOptions, filters]);


    const parameters: ExportKeyValue[] = [
        {
            key: "Sampled",
            value: "false"
        },
        {
            key: "FileName",
            value: 'Person'
        }
    ];

    const peopleTableData = PeopleTableMapper(peopleData, onEditPeopleRow, handleDelete);

    return (
        <>
            <DataTable
                bulkActions={bulkActions}
                key={totalItemsCount}
                table={peopleTableData}
                filters={peopleFilters}
                canSearch
                entriesPerPage={entriesPerPage}
                pageNumber={pageNumber}
                filteredItemsCount={filteredItemsCount}
                totalItemsCount={totalItemsCount}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                searchValueChanged={searchValueChanged}
                isLoading={isLoading}
                filtersChanged={filtersChanged}
                manualSorting={true}
                columnSortingChanged={columnSortingChanged}
            ></DataTable>
            <LoadingButton loading={isRemoveLoading} style={{ float: "right", marginTop: "10px" }} variant='contained' color='secondary' onClick={unusedPeopleClick}>Remove Unused People</LoadingButton>

            {showCreatePeopleModal && <PeopleModal id={personId} closeModal={closeModal} showCreatePeopleModal={showCreatePeopleModal} />}

            <ConfirmationDialog
                isLoading={isConfirmationLoading}
                showDialog={showRemoveUnusedPeopleDialog}
                handleAccept={removeUnusedPeople}
                handleCancel={() => setShowRemoveUnusedPeopleDialog(false)}
                heading={"Confirm Delete"}
                message={removePeopleMessage}
            />
            <ConfirmationDialog
                isLoading={isConfirmationLoading}
                showDialog={showConfirmationDialog}
                handleAccept={onDeletePeopleRow}
                handleCancel={handleCloseConfirmation}
                heading={"Confirm Delete"}
                message={"Are you sure you want to delete this person?"}
            />
            <InformationDialog
                handleAccept={() => setShowInformationDialog(false)}
                heading={"Unable To Delete Person"}
                message={informationMessage}
                messageList={scorecardNames}
                showDialog={showInformationDialog}
            />

            <ImportExportButtonsDialog
                uploadType={DataImportType[DataImportType.Person]}
                controlsEnabled={true}
                showHelpfileDownload={true}
                importBus={true}
                coreExportEnabled={true}
                coreImportEnabled={true}
                type={"Person"}
                typeId={DataImportType.Person}
                parameters={parameters}
                reloadTable={fetchData} />

        </>
    );
}